import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import apiService from "../services/apiService";

const FeedbackList = () => {
  const [feedbacks, setFeedbacks] = useState([]);
  const [totalFeedbacks, setTotalFeedbacks] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const limit = 20;

  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/");
    } else {
      fetchFeedbacks();
    }
  }, [navigate, currentPage]);

  const fetchFeedbacks = async () => {
    try {
      const response = await apiService.postData("admin/feedback-list", {
        limit: limit,
        offset: (currentPage - 1) * limit,
      });

      if (!response.error && response.data?.rows) {
        setFeedbacks(response.data.rows);
        setTotalFeedbacks(response.data.count || response.data.Count);
      }
    } catch (error) {
      console.error("Error fetching feedbacks:", error);
    }
  };

  const totalPages = totalFeedbacks > 0 ? Math.ceil(totalFeedbacks / limit) : 1;
  const isNextDisabled = feedbacks.length < limit || currentPage * limit >= totalFeedbacks;

  return (
    <div className="container mt-4">
      <div className="card">
        <div className="card-header d-flex justify-content-between align-items-center">
          <h4>Feedback List</h4>
        </div>
        <div className="card-body p-0">
          <div className="table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Device ID</th>
                  <th>Mobile</th>
                  <th>Feedback Category</th>
                  <th>Feedback</th>
                </tr>
              </thead>
              <tbody>
                {feedbacks.length > 0 ? (
                  feedbacks.map((fb, index) => (
                    <tr key={fb.feedback_id}>
                      <td>{(currentPage - 1) * limit + index + 1}</td>
                      <td>{fb.User?.deviceId || "-"}</td>
                      <td>{fb.User?.mobile || "-"}</td>
                      <td>{fb.FeedbackCategory?.category_name || "-"}</td>
                      <td>{fb.custom_feedback || "-"}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" className="text-center">
                      No feedback found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <nav className="d-flex justify-content-center align-items-center my-3">
            <button
              className={`btn btn-outline-primary me-2 ${currentPage === 1 ? "disabled" : ""}`}
              onClick={() => setCurrentPage(currentPage - 1)}
              disabled={currentPage === 1}
            >
              «
            </button>
            {Array.from({ length: totalPages }, (_, index) => (
              <button
                key={index + 1}
                className={`btn mx-1 ${
                  currentPage === index + 1 ? "btn-primary" : "btn-outline-primary"
                }`}
                onClick={() => setCurrentPage(index + 1)}
              >
                {index + 1}
              </button>
            ))}
            <button
              className={`btn btn-outline-primary ms-2 ${isNextDisabled ? "disabled" : ""}`}
              onClick={() => setCurrentPage(currentPage + 1)}
              disabled={isNextDisabled}
            >
              »
            </button>
          </nav>
        </div>
      </div>
    </div>
  );
};

export default FeedbackList;
